import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { UsersComponent } from "./pages/users/users.component";
import { MyProfileComponent } from "./pages/my-profile/my-profile.component";

const routes: Routes = [
    { path: '', component: UsersComponent },
    { path: 'my-profile', component: MyProfileComponent },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class UserProfileRoutingModule { }
